import { useNavigateToRoute } from '@lib/navigation';
import { UseNavigateToRouteReturn } from '@lib/navigation/hooks/useNavigateToRoute';

import { EDITOR } from '.';

export const useNavigateToEditor = (): UseNavigateToRouteReturn =>
  useNavigateToRoute(EDITOR);
